// src/features/collaboration/services/inviteLinkService.js
const encode = (value) => encodeURIComponent(value || '');

export const buildInviteContent = ({
  type,
  inviterName,
  groupName,
  link,
  note
}) => {
  const safeInviter = inviterName || 'A colleague';
  const safeLink = link || '';
  const lines = [];

  if (type === 'group') {
    lines.push(
      `Hi! ${safeInviter} invited you to join the Teachmate group "${groupName || 'a group'}".`
    );
    lines.push(`Join here: ${safeLink}`);
  } else {
    lines.push(`Hi! ${safeInviter} invited you to join Teachmate to connect.`);
    lines.push(`Create your account here: ${safeLink}`);
  }

  if (note && note.trim()) {
    lines.push('');
    lines.push(`Message: ${note.trim()}`);
  }

  return lines.join('\n');
};

export const buildMailtoLink = (email, subject, body) => {
  const target = email ? email.trim() : '';
  return `mailto:${encode(target)}?subject=${encode(subject)}&body=${encode(body)}`;
};

export const buildWhatsAppLink = (phone, body) => {
  const digits = (phone || '').replace(/[^\d]/g, '');
  const base = digits ? `https://wa.me/${digits}` : 'https://wa.me/';
  return `${base}?text=${encode(body)}`;
};
